import { Injectable } from '@angular/core';
import { LoadingController, Platform } from '@ionic/angular';
import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;
@Injectable({
  providedIn: 'root'
})

export class CommonService {
  loader: HTMLIonLoadingElement;
  constructor(private loadingCtrl: LoadingController
    , private plt: Platform) { }

  async setItem(keyName, keyValue): Promise<void> {
    await Storage.set({
      key: keyName,
      value: keyValue
    });
  }
  async getItem(keyName): Promise<any> {
    const { value } = await Storage.get({ key: keyName });
    return value;
  }
  async clear() {
    await Storage.clear();
  }
  showLoader = async () => {
    this.loader = await this.loadingCtrl.create({
      message: 'Loading...',
      spinner: 'crescent',
      backdropDismiss: true,
      duration: 5000
    });
    console.log('Loading...present');
    await this.loader.present();
  }

  hideLoader = async () => {
    //this.loadingCtrl.dismiss();
    try {
      this.loader.dismiss();
      console.log('Loading...dismissed');
    }
    catch (err) {
      console.log(JSON.stringify(err));
    }
  }
  //Check if the platform is hybrid
  isHybridPlatform = async (): Promise<boolean> => {
    const readySource = await this.plt.ready();
    console.log('Platform ready from', readySource, this.plt.platforms());
    return this.plt.is('cordova') || this.plt.is('capacitor');
  }
  isPlatformAndroid = async (): Promise<boolean> => {
    const readySource = await this.plt.ready();
    console.log('Platform ready from', readySource, this.plt.platforms());
    return this.plt.is('android');
  }
  isPlatformiOS = async (): Promise<boolean> => {
    const readySource = await this.plt.ready();
    console.log('Platform ready from', readySource, this.plt.platforms());
    return this.plt.is('ios');
  }
}

